import { useMutation } from '@apollo/client';
import { SAVE_USER_PREFERENCE, USER_PREFERENCES } from '..';
/**
 * Custom hook for saving user preferences.
 * @returns An object containing the `savePreference` function.
 */
export const useSavePreference = () => {
    const [savePreferenceMutation] = useMutation(SAVE_USER_PREFERENCE, {
        refetchQueries: [{ query: USER_PREFERENCES }],
    });
    /**
     * Saves a user preference with the specified key and value.
     * @param key - The key of the preference.
     * @param value - The value of the preference.
     */
    const savePreference = async (key, value) => {
        await savePreferenceMutation({
            variables: {
                input: {
                    key,
                    value: JSON.stringify(value),
                },
            },
        });
    };
    return { savePreference };
};
